import React, { Component } from 'react'
import { Link } from 'react-router';

class Home extends Component {
  render() {
    return (
      <div className="home">
        <h1 className="title">Ether DNS</h1>
        <div className="section-one">
          <h2>What's Ether DNS?</h2>
          <p>
            With Ethereum addresses being composed of 40 Hexadecimal characters for benefit of
            security and scalability, it becomes difficult to remember and share.<br />
            Ether DNS is a mapping service that allows setting an
            easy to remember shortcut that is also case insensitive.<br />
            These shortcuts can be used anywhere so that this:<br />
              <i>Donations are welcome at Ethereum address <b>0x5620e912A97bcCbE7c9Ca7572D2C55Eb1343cF7A</b></i><br />
            becomes<br />
              <i>Donations are welcome at <b><Link className="example" to="/e/etherdns">etherdns:etherdns</Link></b></i><br />
          </p>
          <h2>Cost of Registration</h2>
          <p>
            Available shortcuts can be registered for 0.05 Eth.<br />
            Shortcuts sold on the market can be bought at a price set by the owner.<br />
          </p>
          <h2>Selling DNS shortcuts</h2>
          <p>
            When the time comes to part ways with your shortcut you can always place
            your shortcut on the market at any price you feel fit.<br />
            Shortcuts posted for sale include a 10% transaction fee that is paid for by the buyer.<br />
          </p>
          <div className="center cta">
            Want one of your own? <Link className="get-started" to="/set">Head over here</Link>
          </div>
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/layouts/home/Home.js